export default {
    // 报警订阅分组查询接口
    queryAlarmSubscribeGroup(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/queryAlarmSubscribeGroup', params, response);
    },
    // 报警推送信息查询接口
    getAlarmSend(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/getAlarmSend', params, response);
    },
    // 报警推送信息保存接口
    saveAlarmSend(params, response) {
        if (params.sId == '') {
            window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/addAlarmSend', JSON.stringify(params), response);
        } else {
            window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/updateAlarmSend', JSON.stringify(params), response);
        }
    },
    // 报警推送信息删除接口
    deleteAlarmSend(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/deleteAlarmSend', params, response);
    }
};
